import { render, staticRenderFns } from "./detail-aside.vue?vue&type=template&id=758395ba&scoped=true&"
import script from "./detail-aside.vue?vue&type=script&lang=js&"
export * from "./detail-aside.vue?vue&type=script&lang=js&"
import style0 from "./detail-aside.vue?vue&type=style&index=0&id=758395ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758395ba",
  null
  
)

export default component.exports